import Vue from "vue";
import Vuex from "vuex";
import _ from 'lodash';
import api from '@/api';

Vue.use(Vuex);

// import  vuetron from 'vuetron';


var modules = {};

function loadStores(requireContext) {
  var keys = requireContext.keys();
  _.forEach(keys, k => {
    var modulo = requireContext(k)
    var nome = k.match(/([^/]*).js$/)
    modules[k] = modulo.default;
  })
}
loadStores(require.context("./store-client", true, /^\.\/.*\.js$/));
loadStores(require.context("./store-common", true, /^\.\/.*\.js$/));



const debug = process.env.NODE_ENV !== 'production'


let STORE_INITIALISED = false

export default function (data = {}) {

  var modulesFinal = {}
  _.each(modules,(module,k)=>{
    let name = k.replace(/.js/g,'')
    name = name.replace(/[ˆ\W]/g,'')
    modulesFinal[name] = module(data)
  })

  var store = new Vuex.Store({
    state: {},
    mutations: {
      initialiseStore(state) {
        // Check if the ID exists
        if(localStorage.getItem('store')) {
          console.log('initialiseStore=====')
          // Replace the state object with the stored item
          this.replaceState(
            Object.assign(state, JSON.parse(localStorage.getItem('store')))
          );
        }
        STORE_INITIALISED = true
      }
    },
    actions: {},
    getters: {},
    plugins:[],
    strict: debug,
    modules:modulesFinal
  });

  store.subscribe((mutation, state) => {
    if(STORE_INITIALISED){
      // Store the state object as a JSON string
      console.log('mutation',mutation)
      console.log('state',state)
      localStorage.setItem('store', JSON.stringify(state));
    }
  });

  window.$store = store
  window.store = store

  return store;
}
